import { isEqual } from 'lodash';
import {
  CreateCategoriesRequest,
  DeleteCategoriesRequest,
} from '@tiendanube/common';

type CategoriesPayload = (CreateCategoriesRequest | DeleteCategoriesRequest)[];

export const generateCategoriesPayload = (
  originalCategories: string[],
  newCategories: string[] | undefined,
): { categories: CategoriesPayload } | undefined => {
  if (!newCategories || isEqual(originalCategories, newCategories)) {
    return undefined;
  }
  const categoriesToCreate: CreateCategoriesRequest[] = [];
  const categoriesToDelete: DeleteCategoriesRequest[] = [];

  originalCategories.forEach((category) => {
    if (!newCategories.includes(category)) {
      categoriesToDelete.push({ id: Number(category), '@delete': true });
    }
  });

  newCategories.forEach((category, index) => {
    if (!originalCategories.includes(category)) {
      categoriesToCreate.push({ id: Number(category), order: index });
    }
  });

  return { categories: [...categoriesToCreate, ...categoriesToDelete] };
};
